<template>
  <main id="main-container">
    <Hero title="Administrador" page="Administrador" />
    <div class="content">
      <h2>Menu</h2>
      <div class="row">
        <Card title="Crear Nueva Cuenta">
          <div class="row">
            <form class="form-class" @submit.prevent="createEmailRegistration">
              <div class="col-md-6 col-12">
                <label for="" class="form-label">Email</label>
                <input
                  class="form-control"
                  label="Email"
                  type="text"
                  placeholder="My Email"
                  v-model="new_account.email"
                  required
                />
              </div>
              <br />
              <a @click="copyClipboard" class="col-12">{{ new_account.link }}</a>
              <div class="col-12" v-if="new_account.link != ''">
                <button
                  class="btn btn-info mb-3 pull-left"
                  @click="copyClipboard"
                >
                  Copy
                </button>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-info mb-3 pull-right">
                  Crear
                </button>
              </div>
            </form>
          </div>
        </Card>
      </div>

      <div class="row">
        <Card title="Actualizar Via OTA">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <label for="" class="form-label">Link</label>
              <input
                class="form-control"
                type="url"
                placeholder="Link"
                v-model="ota_data.link"
              />
            </div>
            <div class="col-md-6 col-sm-12">
              <label for="" class="form-label">Serial</label>
              <input
                class="form-control"
                type="text"
                placeholder="Serial"
                v-model="ota_data.dId"
              />
            </div>
          </div>

          <div class="row pull-right">
            <div class="col-12">
              <button class="btn btn-info mb-3 mt-4" @click="sendUrlOta">
                Enviar
              </button>
            </div>
          </div>
        </Card>
      </div>

      <form class="form-class" @submit.prevent="createNewDevice()">
        <div class="row">
          <Card title="Create New Device">
            <div class="row">
              <div class="col-4">
                <label for="" class="form-label">Email Cliente</label>
                <input
                  class="form-control"
                  type="email"
                  placeholder="Client Email"
                  v-model="email_device"
                  required
                />
              </div>

              <div class="col-4">
                <label for="" class="form-label">Nombre Dispositivo</label>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Ex: Home, Office..."
                  v-model="newDevice.name"
                  required
                />
              </div>

              <div class="col-4">
                <label for="" class="form-label">Dispositivo Id</label>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Ex: 7777-8888"
                  v-model="newDevice.dId"
                  required
                />
              </div>

              <div class="col-4">
                <label for="" class="form-label">Seleccionar Plantilla</label>+
                <select
                  class="form-select"
                  placeholder="Seleccionar Plantilla"
                  required
                  v-model="selectedIndexTemplate"
                >
                  <option
                    v-for="(template, index) in templates"
                    v-bind:key="index"
                    :value="index"
                    :label="template.name"
                  ></option>
                </select>
              </div>

              <div class="col-4 mt-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    v-model="newDevice.ext_mqtt"
                    type="checkbox"
                  />
                  <label class="form-check-label"> Dispositivo Externo </label>
                </div>
              </div>
            </div>

            <div class="row pull-right">
              <div class="col-12">
                <button type="submit" class="btn btn-info mb-3">Add</button>
              </div>
            </div>
          </Card>
        </div>
      </form>
      <!-- Client TABLE -->
      <div class="row">
        <Card title="Lista de Clientes">
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-vcenter">
              <thead>
                <th>#</th>
                <th>Nombre</th>
                <th>Rol</th>
                <th>Email</th>
                <th class="text-center" style="width: 100px">Accion</th>
              </thead>
              <tbody>
                <tr v-for="(row, index) in users_data" v-bind:key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.role }}</td>
                  <td>{{ row.email }}</td>
                  <td>
                    <div class="form-check form-switch">
                      <i
                        class="fa fa-user"
                        :class="{
                          'text-success': row.is_active,
                          'text-dark': !row.is_active,
                        }"
                      ></i>
                      <input
                        class="form-check-input"
                        @click="updateUserStatus(row._id, !row.is_active)"
                        v-model="row.is_active"
                        type="checkbox"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "@/axios";
import router from "@/router";
import useApp from "@/composables/useApp";
export default {
  name: "admin",
  components: {},

  data() {
    return {
      ota_data: {
        link: "",
        dId: "",
      },
      users_data: [],
      templates: [],
      selectedIndexTemplate: null,
      email_device: "",

      newDevice: {
        name: "",
        dId: "",
        templateId: "",
        templateName: "",
        ext_mqtt: false,
      },

      new_account: {
        email: "",
        link: "",
      },
    };
  },

  mounted() {
    if (!this.$store.state.auth.userData.is_admin) {
      router.push("/dashboard");
    }
    const { ToastMsg, ToastMsgError, ToastMsgInfo, ToastMsgWarning } = useApp();
    this.ToastMsg = ToastMsg;
    this.ToastMsgError = ToastMsgError;
    this.ToastMsgInfo = ToastMsgInfo;
    this.ToastMsgWarning = ToastMsgWarning;
    this.getUsers();
    this.getTemplates();
  },

  methods: {
    copyClipboard() {
      try {
        navigator.clipboard.writeText(this.new_account.link)
        .then(() => {
          this.ToastMsgInfo("Copiado al Portapapeles", "server", 5000);
        });
      } catch (err) {
        this.ToastMsgError("Error al Copiar", "server", 5000);
      }
    },
    sendUrlOta() {
      if (this.ota_data.link == "" || this.ota_data.dId == "") {
        this.ToastMsgWarning("Formulario No valido es nulo", "user", 5000);
        return;
      }

      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };
      axios
        .post("/update-ota-device", this.ota_data, axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.ToastMsgInfo(res.data.message, "user", 5000);
          }
        })
        .catch((e) => {
          console.log(e);
          this.ToastMsgError(e.response.data.error, "user", 5000);
        });
    },

    createNewDevice() {
      if (!this.validEmail(this.email_device)) {
        this.ToastMsgInfo("Email No Valido", "user", 5000);
        return;
      }

      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      //ESCRIBIMOS EL NOMBRE Y EL ID DEL TEMPLATE SELECCIONADO EN EL OBJETO newDevice
      this.newDevice.templateId =
        this.templates[this.selectedIndexTemplate]._id;
      this.newDevice.templateName =
        this.templates[this.selectedIndexTemplate].name;

      const toSend = {
        newDevice: this.newDevice,
        email: this.email_device,
      };

      axios
        .post("/device-admin", toSend, axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            this.newDevice.name = "";
            this.newDevice.dId = "";
            this.selectedIndexTemplate = null;
            this.ToastMsg("Completado Dispositivo Agregado", "server", 5000);
            return;
          }
        })
        .catch((e) => {
          console.log(e.response);

          if (e.response.status == 404) {
            this.ToastMsgError(e.response.data.error);
            return;
          }

          if (e.response.data.status == "error" && e.response.status == 503) {
            this.ToastMsgError(e.response.data.error, "user", 5000);
            return;
          }

          if (
            e.response.data.status == "error" &&
            e.response.data.error.errors.dId.kind == "unique"
          ) {
            this.ToastMsgError("Dispositivo Ya Registrado", "user", 5000);
            return;
          }
        });
    },

    async getUsers() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      try {
        const res = await axios.get("/user-list", axiosHeaders);
        const users_data = res.data.users;
        this.users_data = users_data.filter((user) => !user.is_admin);
      } catch (error) {
        this.ToastMsgInfo("Error solicitando Usuarios", "user", 5000);
        console.log(error);
        return;
      }
    },

    async updateUserStatus(user_id, status) {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      const body = {
        user_id,
        status,
      };

      try {
        const res = await axios.put("/user-status-update", body, axiosHeaders);

        if (res.data.status == "success") {
          this.ToastMsgInfo("Usuario Actualizado", "user", 5000);
        }

        this.getUsers();
      } catch (error) {
        this.ToastMsgError("Error al actulizar Usuario", "user", 5000);
        console.log(error);
      }
    },

    async getTemplates() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      try {
        const res = await axios.get("/template", axiosHeaders);

        if (res.data.status == "success") {
          this.templates = res.data.data;
        }
      } catch (error) {
        this.ToastMsgError("Error en Templates..", "user", 5000);
        console.log(error);
        return;
      }
    },

    validEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    createEmailRegistration() {
      if (!this.validEmail(this.new_account.email)) {
        alert("Email is not valid !");
        return;
      }
      this.new_account.email = this.new_account.email.toLowerCase();
      this.new_account.link =
        location.protocol + "//" + location.host + "/register?token=";

      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      const toSend = {
        email: this.new_account.email,
        link: this.new_account.link,
      };

      axios
        .post("/create-email-registration", toSend, axiosHeaders)
        .then((res) => {
          if (res.data.status == "success") {
            const token = res.data.token;
            this.ToastMsgInfo("Token Registrado Correctamente", "user", 5000);
            this.new_account.link +=
              encodeURIComponent(token) +
              "&email=" +
              encodeURIComponent(res.data.email);
            return;
          }
        })
        .catch((err) => {
          this.ToastMsgError(err.response.data.error, "user", 5000);
          return;
        });
    },
  },
};
</script>
